import React from "react";
import { useNavigate } from 'react-router-dom';
import DC from "../../../common/DataConnector";
import TokenStore from "../../../common/TokenStore";
import { credentialLoad, ordersLoad } from "../../../store/UserData/UserData";
import { actLoading, actLoadingEnd } from "../../../store/Actions";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";


export default function UserLoginEnd()
{
    const dispatch = useAppDispatch()
    const userData = useAppSelector((state) => state.userData)
    const navigate = useNavigate();
    React.useEffect(() =>
    {
        (async function ()
        {
            actLoading(dispatch)
            validateCode()
            actLoadingEnd(dispatch)
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function validateCode()
    {
        const params: any = new URLSearchParams(window.location.search)
        let content = await DC.Post('/customer/login-google', { code: params.get('code') });
        if (content.wasOk) {
            TokenStore.set(content.data)
            await credentialLoad(userData, dispatch)
            await ordersLoad(dispatch)
            navigate('/user');
        } else
            navigate('/');
    }
    return (<></>)
}